import { SearchProvider } from '@cast/shared-search-ui';
import { Box } from '@cast/design-system';
import { CostReportProvider } from '@cast/split-me/features/cost-report';
import {
  useReducedWorkloads,
  useWorkloadsSearchCriteria,
  WorkloadFilters,
  WorkloadsListSection,
  WorkloadsNetworkCostOverTimeProvider,
} from '@cast/split-me/features/cluster/cost-report';
import { WORKLOAD_CATEGORIES } from '../../../_constants';
import { useInventoryMonitoringWorkloadLink } from '../../../_hooks/useInventoryMonitoringWorkloadLink';
import { inventoryWorkloadsTableKeys, tableCacheKeys } from '../../../consts';

const NetworkContent = () => {
  const criteria = useWorkloadsSearchCriteria();
  const getWorkloadLink = useInventoryMonitoringWorkloadLink(
    WORKLOAD_CATEGORIES.NETWORK
  );

  return (
    <WorkloadsNetworkCostOverTimeProvider>
      <SearchProvider
        criteria={criteria}
        useData={useReducedWorkloads}
        urlKey={inventoryWorkloadsTableKeys.NETWORK}
        serverSideSort
        disableFreeText
      >
        <Box mb={15}>
          <WorkloadFilters size="small" />
        </Box>
        <WorkloadsListSection
          cacheKey={tableCacheKeys.INVENTORY_WORKLOADS.NETWORK}
          getWorkloadLink={({ namespace, workloadName, workloadType }) =>
            getWorkloadLink({
              namespace,
              workloadName,
              workloadType,
            })
          }
        />
      </SearchProvider>
    </WorkloadsNetworkCostOverTimeProvider>
  );
};

export const InventoryWorkloadsListNetwork = () => (
  <CostReportProvider>
    <NetworkContent />
  </CostReportProvider>
);
